import { FC } from "react";
import { isMediaUrl } from "./utils";
import { CommentMediaGrid } from "./components/CommentMediaGrid";
import { CommentFileList } from "./components/CommentFileList";

interface CommentAttachmentsProps {
  attachments: string[];
  onAttachmentClick?: (url: string, allUrls: string[]) => void;
  onDownload?: (url: string) => void;
}

export const CommentAttachments: FC<CommentAttachmentsProps> = ({
  attachments,
  onAttachmentClick,
  onDownload,
}) => {
  if (attachments.length === 0) return null;

  const allMedia = attachments.every(isMediaUrl);

  if (allMedia) {
    return (
      <CommentMediaGrid
        attachments={attachments}
        onAttachmentClick={onAttachmentClick}
      />
    );
  }

  return (
    <CommentFileList
      attachments={attachments}
      onAttachmentClick={onAttachmentClick}
      onDownload={onDownload}
    />
  );
};
